<template>
  <div
    :style="module.containerStyle"
    :data-tangram-module-id="module.id"
    :class="['tangram-coupons', component]"
  >
    <div
      v-for="group in module.data"
      :key="group.actionId"
      :style="group.couponPackStyle"
      :class="['group', component]"
    >
      <component
        :is="'coupon' + coupon.couponType"
        v-for="coupon in group.couponInfos"
        :key="coupon.id"
        :coupon="coupon"
        :coupon-style="coupon.contentStyle"
        :show-type="coupon.showType"
        :can-get="coupon.canGet"
        :coupon-type="coupon.couponType"
        :stock-status="group.stockstatus"
        :coupon-value="coupon.faceValue"
        :coupon-name="coupon.name"
        :threshold-msg="coupon.thresholdMsg"
        :percentage="group.percentage"
        @receive-coupon="receiveCoupon(group, coupon)"
      />
    </div>
    <van-loading v-if="showLoading" class="loading" type="spinner" size="32" />
  </div>
</template>

<script>
import coupon1N from './components/coupon1N'
import coupon2N from './components/coupon2N'
import couponScroll from './components/couponScroll'
import couponSlide from './components/couponSlide'
import { API } from '@/api'
export default {
  name: 'Coupons',
  components: {
    coupon1N,
    coupon2N,
    couponScroll,
    couponSlide
  },
  props: {
    module: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showLoading: false
    }
  },
  created() {
    // 优惠券组件
    this.component = 'coupon' + this.module.couponType
  },
  methods: {
    async receiveCoupon(group, coupon) {
      if (this.module.couponType !== 'Slide') {
        this.showLoading = true
      }

      const res = await this.callModule(this.module.events.receiveCoupon, {
        groupActionId: group.actionId,
        couponId: coupon.id
      })
      if (res.ret) {
        this.$toast({
          message: '领取成功',
          icon: 'success'
        })
        const refresh = await this.getRefreshContent()
        this.postMessage({
          id: this.module.id,
          event: this.module.events.refresh,
          data: refresh
        })
        // 领取成功的时候不需要关 loading, 因为要刷新，整个 dom 都被换了，loading 自然就没了
      } else if (res.error?.res?.error?.msg) {
        this.showLoading = false
        this.$toast(res.error.res.error.msg)
      }
    },
    async getRefreshContent() {
      try {
        const res = await API.cms.getById({
          pageid: this.module.pageId,
          moduleids: `${this.module.id}`
        })
        return res
      } catch (error) {
        return Promise.reject(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.coupons {
  position: relative;
}
.tangram-coupons {
  &.couponSlide {
    overflow-x: auto;
    @include flex(row, flex-start, center, nowrap);

    &::-webkit-scrollbar {
      display: none;
    }
  }
}

.group {
  &.coupon2N {
    @include flex(row, space-between, center, wrap);
  }

  &.couponScroll {
    overflow-x: auto;
    @include flex(row, flex-start, center, nowrap);

    &::-webkit-scrollbar {
      display: none;
    }
  }
  &.couponSlide {
    display: flex;

    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
}

.loading {
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, 0.6);

  @include flex-row-center;
}
</style>
